/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>考核数据</el-breadcrumb-item>
      <el-breadcrumb-item>区域经理家用详情</el-breadcrumb-item>
    </el-breadcrumb>
   
	 <div class="titleout">
		 <div class="title">考核数据详情-家用</div>
		 <div class="title1">{{name}}|{{ofVillage.phoneNumber}}</div>
		 <div class="title1">{{area}}</div>
		 <div class="backcss">
		   <el-button size="small" type="primary" @click="goback">返回</el-button>
		 </div>
	 </div>	 
	 <div class="block">
		 <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;" @change="choosebt">
			 <el-radio-button label="month" >月</el-radio-button>
			 <el-radio-button label="year">年</el-radio-button>
			 <!-- <el-radio-button label="date">日</el-radio-button> -->
		 </el-radio-group>
		 <el-date-picker
		   v-model="value2"
		   type="month"
		   placeholder="选择月" 
		   v-if="tabPosition=='month'"
		   @change="changemonth"
		   value-format="yyyy-MM">
		 </el-date-picker>
		 
		 <el-date-picker
		   v-model="value3"
		   type="year"
		   placeholder="选择年"
		   v-if="tabPosition=='year'"
		   @change="changeyear"
		   value-format="yyyy">
		 </el-date-picker>
		 
		  <el-date-picker
		   v-model="value1"
		   type="date"
		   placeholder="选择日期"
		   v-if="tabPosition=='date'"
		   @change="changedata"
		   value-format="yyyy-MM-dd">
		  </el-date-picker>
			 
	   </div>
	   
	   <div class="jinduout">
		   <div class="jindulist" v-if="kpilist[0]">
			   <div class="shu1" v-if="percentagedata">{{kpilist[0].finishedNum}}</div>
			   <div class="shu" v-else>{{kpilist[0].finishedNum}}</div>
			   <div class="titlejin1" v-if="percentagedata">{{kpilist[0].kpiName}}</div>
			   <div class="titlejin" v-else>{{kpilist[0].kpiName}}</div>
			   <div class="jundut" v-if="percentagedata">
				   <el-progress :percentage="percentagedata" define-back-color="#f2cfd3" color="#de868f" :stroke-width="12" :show-text="false"></el-progress>
				   <div class="titleout">
					   <div class="mubiao">目标值：{{kpilist[0].targetNum}}</div>
					   <div class="mubiao">{{kpilist[0].progressPercent}}%</div>
				   </div>
			   </div>
		   </div>
		   
		   <div class="jindulist1" v-if="kpilist[1]">
			   <div class="shu1" v-if="percentagedata1">{{kpilist[1].finishedNum}}</div>
			   <div class="shu" v-else>{{kpilist[1].finishedNum}}</div>
			   <div class="titlejin1" v-if="percentagedata1">{{kpilist[1].kpiName}}</div>
			   <div class="titlejin" v-else>{{kpilist[1].kpiName}}</div>
			   <div class="jundut" v-if="percentagedata1">
				   <el-progress :percentage="percentagedata1" define-back-color="#fde995" color="#f9ca00" :stroke-width="12" :show-text="false"></el-progress>
				   <div class="titleout">
					   <div class="mubiao">目标值：{{kpilist[1].targetNum}}</div>
					   <div class="mubiao">{{kpilist[1].progressPercent}}%</div>
				   </div>
			   </div>
		   </div>
		   
		   <div class="jindulist2" v-if="kpilist[2]">
			   <div class="shu1" v-if="percentagedata2">{{kpilist[2].finishedNum}}</div>
			   <div class="shu" v-else>{{kpilist[2].finishedNum}}</div>
			   <div class="titlejin1" v-if="percentagedata2">{{kpilist[2].kpiName}}</div>
			   <div class="titlejin" v-else>{{kpilist[2].kpiName}}</div>
			   <div class="jundut" v-if="percentagedata2">
				   <el-progress :percentage="percentagedata2" define-back-color="#fbebd6" color="#f5ce99" :stroke-width="12" :show-text="false"></el-progress>
				   <div class="titleout">
					   <div class="mubiao">目标值：{{kpilist[2].targetNum}}</div>
					   <div class="mubiao">{{kpilist[2].progressPercent}}%</div>
				   </div>
			   </div>
		   </div>
		   
		   <div class="jindulist3" v-if="kpilist[3]">
			   <div class="shu1" v-if="percentagedata3">{{kpilist[3].finishedNum}}</div>
			   <div class="shu" v-else>{{kpilist[3].finishedNum}}</div>
			   <div class="titlejin1" v-if="percentagedata3">{{kpilist[3].kpiName}}</div>
			   <div class="titlejin" v-else>{{kpilist[3].kpiName}}</div>
			   <div class="jundut" v-if="percentagedata3">
				   <el-progress :percentage="percentagedata3" define-back-color="#ebfccf" color="#ccf784" :stroke-width="12" :show-text="false"></el-progress>
				   <div class="titleout">
					   <div class="mubiao">目标值：{{kpilist[3].targetNum}}</div>
					   <div class="mubiao">{{kpilist[3].progressPercent}}%</div>
				   </div>
			   </div>
		   </div>
		   
		   <div class="jindulist4" v-if="kpilist[4]">
			   <div class="shu1" v-if="percentagedata4">{{kpilist[4].finishedNum}}</div>
			   <div class="shu" v-else>{{kpilist[4].finishedNum}}</div>
			   <div class="titlejin1" v-if="percentagedata4">{{kpilist[4].kpiName}}</div>
			   <div class="titlejin" v-else>{{kpilist[4].kpiName}}</div>
			   <div class="jundut" v-if="percentagedata4">
				   <el-progress :percentage="percentagedata4" define-back-color="#cdd0fc" color="#7f83f7" :stroke-width="12" :show-text="false"></el-progress>
				   <div class="titleout">
					   <div class="mubiao">目标值：{{kpilist[4].targetNum}}</div>
					   <div class="mubiao">{{kpilist[4].progressPercent}}%</div>
				   </div>
			   </div>
		   </div>
		   
		   <div class="jindulist5" v-if="kpilist[5]">
			   <div class="shu1" v-if="percentagedata4">{{kpilist[5].finishedNum}}</div>
			   <div class="shu" v-else>{{kpilist[5].finishedNum}}</div>
			   <div class="titlejin1" v-if="percentagedata4">{{kpilist[5].kpiName}}</div>
			   <div class="titlejin" v-else>{{kpilist[5].kpiName}}</div>
			   <div class="jundut" v-if="percentagedata4">
				   <el-progress :percentage="percentagedata4" define-back-color="#e3cffc" color="#b886f8" :stroke-width="12" :show-text="false"></el-progress>
				   <div class="titleout">
					   <div class="mubiao">目标值：{{kpilist[5].targetNum}}</div>
					   <div class="mubiao">{{kpilist[5].progressPercent}}%</div>
				   </div>
			   </div>
		   </div>
		  
		   
	   </div>
	   
	   
	   <div class="block">
	   		 <el-radio-group v-model="tabPositiontype" style="margin-bottom: 30px;" @change="changetype">
				 <el-radio-button label="销量">销量</el-radio-button>
				 <el-radio-button label="新商开发">新商开发</el-radio-button>
	   			 <el-radio-button label="驻镇代表" >驻镇代表</el-radio-button>
	   			 <el-radio-button label="终端准用户">终端准用户</el-radio-button>
	   			 <el-radio-button label="订购会">订购会</el-radio-button>
				 <el-radio-button label="月新商拜访">月新商拜访</el-radio-button>
	   		 </el-radio-group>
	   		
	     </div>
	   
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
		  
		  <el-table-column v-if="tabPositiontype=='销量'" align="center" prop="grossAmount" label="经销商含税金额" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='销量'" align="center" prop="businessMonth" label="业务月份" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='销量'" align="center" prop="updateTime" label="最后更新时间" >
		  </el-table-column>
		  
		  <el-table-column v-if="tabPositiontype=='新商开发'" align="center" prop="actualNumber" label="实际个数" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='新商开发'" align="center" prop="accountingMonth" label="核算月份" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='新商开发'" align="center" prop="updateTime" label="最后更新时间" >
		  </el-table-column>
		  
		  
		  
          <el-table-column v-if="tabPositiontype=='驻镇代表'" align="center" prop="zzdbName" label="名称" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='驻镇代表'" align="center" prop="zzdbMobile" label="手机号" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='驻镇代表'" align="center" prop="zzdbArea" label="地区" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='驻镇代表'" align="center" prop="totalScore" label="Kpi考核总分" >
		  </el-table-column>
		  <el-table-column align="center" label="拜访用户" v-if="tabPositiontype=='驻镇代表'">
				  <template slot-scope="scope">
				  <div>目标:{{scope.row.visitUserDto.targetNum}}{{scope.row.visitUserDto.unit}}</div>
				  <div>完成:{{scope.row.visitUserDto.finishedNum}}{{scope.row.visitUserDto.unit}}</div>
				  <div>进度:{{scope.row.visitUserDto.progressPercent}}%</div>
				  <div>权重:{{scope.row.visitUserDto.weightPercent}}%</div>
				  <div>得分:{{scope.row.visitUserDto.score}}分</div>
				  </template>
		  </el-table-column>
		  <el-table-column align="center" label="准用户" v-if="tabPositiontype=='驻镇代表'">
			  <template slot-scope="scope">
			  <div>目标:{{scope.row.potentialUserDto.targetNum}}{{scope.row.potentialUserDto.unit}}</div>
			  <div>完成:{{scope.row.potentialUserDto.finishedNum}}{{scope.row.potentialUserDto.unit}}</div>
			  <div>进度:{{scope.row.potentialUserDto.progressPercent}}%</div>
			  <div>权重:{{scope.row.potentialUserDto.weightPercent}}%</div>
			  <div>得分:{{scope.row.potentialUserDto.score}}分</div>
			  </template>
		  </el-table-column>
		  <el-table-column align="center" label="成交用户" v-if="tabPositiontype=='驻镇代表'">
			  <template slot-scope="scope">
			  <div>目标:{{scope.row.transactionUserDto.targetNum}}{{scope.row.transactionUserDto.unit}}</div>
			  <div>完成:{{scope.row.transactionUserDto.finishedNum}}{{scope.row.transactionUserDto.unit}}</div>
			  <div>进度:{{scope.row.transactionUserDto.progressPercent}}%</div>
			  <div>权重:{{scope.row.transactionUserDto.weightPercent}}%</div>
			  <div>得分:{{scope.row.transactionUserDto.score}}分</div>
			  </template>
		  </el-table-column>
		  <el-table-column align="center" label="单叶发放" v-if="tabPositiontype=='驻镇代表'">
			  <template slot-scope="scope">
			  <div>目标:{{scope.row.singlePageDto.targetNum}}{{scope.row.singlePageDto.unit}}</div>
			  <div>完成:{{scope.row.singlePageDto.finishedNum}}{{scope.row.singlePageDto.unit}}</div>
			  <div>进度:{{scope.row.singlePageDto.progressPercent}}%</div>
			  <div>权重:{{scope.row.singlePageDto.weightPercent}}%</div>
			  <div>得分:{{scope.row.singlePageDto.score}}分</div>
			  </template>
		  </el-table-column>
		  <el-table-column align="center" prop="posterPasteNum" label="海报黏贴" v-if="tabPositiontype=='驻镇代表'">
			  <template slot-scope="scope">
			  <div>目标:{{scope.row.posterPasteDto.targetNum}}{{scope.row.posterPasteDto.unit}}</div>
			  <div>完成:{{scope.row.posterPasteDto.finishedNum}}{{scope.row.posterPasteDto.unit}}</div>
			  <div>进度:{{scope.row.posterPasteDto.progressPercent}}%</div>
			  <div>权重:{{scope.row.posterPasteDto.weightPercent}}%</div>
			  <div>得分:{{scope.row.posterPasteDto.score}}分</div>
			  </template>
		  </el-table-column>
		  
		  
		  <el-table-column v-if="tabPositiontype=='终端准用户'" align="center" prop="name" label="名称" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='终端准用户'" align="center" prop="phoneNumber" label="手机号" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='终端准用户'" align="center" prop="area" label="地区" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='终端准用户'" align="center" prop="createTime" label="成为准用户时间" >
		  </el-table-column>
		  
		  
		  
		  <el-table-column v-if="tabPositiontype=='订购会'" align="center" prop="creator" label="创建人" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='订购会'" align="center" prop="name" label="订购会名称" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='订购会'" align="center" prop="eventTime" label="执行时间" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='订购会'" align="center" prop="address" label="订购会地点" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='订购会'" align="center" prop="createTime" label="创建时间" >
		  </el-table-column>
		  
		  
		  
		  <el-table-column v-if="tabPositiontype=='月新商拜访'" align="center" prop="name" label="名称" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='月新商拜访'" align="center" prop="phoneNumber" label="手机号" >
		  </el-table-column>
		  <el-table-column v-if="tabPositiontype=='月新商拜访'" align="center" prop="createTime" label="拜访时间" >
		  </el-table-column>
		  
		  
		 
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        
      </div>
    </template>

    <script>
    import {
		
	  getDetailKpiDataOfRegionalManagerHouse,
	  queryPageSale,
	  queryPageDevelopDealer,
	  queryPageTown,
	  queryPageCustomer,
	  queryPageMeeting,
	  kpiDataVisitDealerHouse
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
		  percentagedata:10,
		  percentagedata1:10,
		  percentagedata2:10,
		  percentagedata3:10,
		  percentagedata4:10,
		  percentagedata5:10,
         tabPosition: 'month',
		 tabPositiontype:'销量',
		 value2:'',
		 value3:'',
		 value1:'',
		 name:'',
		 area:'',
		 kpilist:[],
          // 请求数据参数
          formProInfo: {
            pageIndex: 1,
            pageSize: 10,
            dataType:'1',
		   accountId:'',
		   userId:'',
		   year:'',
		   month:''
			
          },
		  // 请求数据参数
		  formMeeting: {
		    pageIndex: 1,
		    pageSize: 10,
		    dataType:'1',
		   accountId:'',
		   year:'',
		   month:''
		  			
		  },
		  
		  // 请求数据参数
		  formProInfos: {
		    pageIndex: 1,
		    pageSize: 10,
		   accountId:'',
		   dataType:'3',
		   customerStatus:'准意向用户',
		   year:'',
		   month:''
		  },
		  // 请求数据参数
		  ofVillage: {
		   accountId:'',
		   userId:'',
		   phoneNumber:'',
		   year:'',
		   month:''
		  },
    	  proInfoList:[],
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          }
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
		const now = new Date()
        this.ofVillage.userId = this.$route.query.id
		this.formProInfo.userId = this.$route.query.id
		this.ofVillage.accountId = this.$route.query.aid
		this.formProInfo.accountId = this.$route.query.aid
		this.formProInfos.accountId = this.$route.query.aid
		this.formMeeting.accountId = this.$route.query.aid
		this.ofVillage.phoneNumber = this.$route.query.ph
		this.formProInfo.phoneNumber = this.$route.query.ph
		this.name = this.$route.query.na
		this.area = this.$route.query.ar
		this.value2 = this.getCurrentYearMonth()
		this.formProInfo.month = this.value2.substring(this.value2.length - 2)
		this.formProInfo.year = String(now.getFullYear())
		this.formProInfo.date = this.value1
		this.formProInfos.month = this.value2.substring(this.value2.length - 2)
		this.formProInfos.year = String(now.getFullYear())
		this.formProInfos.date = this.value1
		this.ofVillage.month = this.value2.substring(this.value2.length - 2)
		this.ofVillage.year = String(now.getFullYear())
		this.ofVillage.date = this.value1
		this.formMeeting.month = this.value2.substring(this.value2.length - 2)
		this.formMeeting.year = String(now.getFullYear())
		this.formMeeting.date = this.value1
		this.getDetailKpi(this.ofVillage)
		this.getData(this.formProInfo)
		console.log(66667,this.formProInfos.workType)
      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  goback() {
		  	this.$router.push({ path: '/regionalManager'})
		   
		  },
		  changedata(e){
			  this.formProInfo.date = this.value1
			   this.formProInfos.date = this.value1
			  this.ofVillage.date = this.value1
			 if(this.tabPositiontype=='驻镇代表'){
			 					
				 this.getData(this.formProInfo)
			 }else if(this.tabPositiontype=='终端准用户'){
				this.getDatas(this.formProInfos) 
			 				
			 }else if(this.tabPositiontype=='销量'){
				this.getPageGoods(this.formProInfo) 
			 				
			 }else if(this.tabPositiontype=='新商开发'){
				this.getDevelopDealer(this.formProInfo) 
			 				
			 }else if(this.tabPositiontype=='订购会'){
				this.getVisitDealer(this.formMeeting) 
			 				
			 }else{
				this.VisitDealerBusiness(this.formProInfo)
			 				
			 }
			  this.getDetailKpi(this.ofVillage)
		  },
		  changeyear(e){
			  this.formProInfo.year = this.value3
			  this.formProInfos.year = this.value3
			   this.ofVillage.year = this.value3
			   this.formMeeting.year = this.value3
			  if(this.tabPositiontype=='驻镇代表'){
			  					
			  		this.getData(this.formProInfo)
			  }else if(this.tabPositiontype=='终端准用户'){
			  		this.getDatas(this.formProInfos) 
			  				
			  }else if(this.tabPositiontype=='销量'){
			  		this.getPageGoods(this.formProInfo) 
			  				
			  }else if(this.tabPositiontype=='新商开发'){
			  		this.getDevelopDealer(this.formProInfo) 
			  				
			  }else if(this.tabPositiontype=='订购会'){
			  		this.getVisitDealer(this.formMeeting) 
			  				
			  }else{
			  		this.VisitDealerBusiness(this.formProInfo)
			  				
			  }
			  this.getDetailKpi(this.ofVillage)
		  },
		  changemonth(e){
			  console.log(999999,this.value2)
			  this.formProInfo.month = this.value2.substring(this.value2.length - 2)
			  this.formProInfos.month = this.value2.substring(this.value2.length - 2)
			   this.ofVillage.month = this.value2.substring(this.value2.length - 2)
			   this.formMeeting.month = this.value2.substring(this.value2.length - 2)
			  if(this.tabPositiontype=='驻镇代表'){
			  					
			  		this.getData(this.formProInfo)
			  }else if(this.tabPositiontype=='终端准用户'){
			  		this.getDatas(this.formProInfos) 
			  				
			  }else if(this.tabPositiontype=='销量'){
			  		this.getPageGoods(this.formProInfo) 
			  				
			  }else if(this.tabPositiontype=='新商开发'){
			  		this.getDevelopDealer(this.formProInfo) 
			  				
			  }else if(this.tabPositiontype=='订购会'){
			  		this.getVisitDealer(this.formMeeting) 
			  				
			  }else{
			  		this.VisitDealerBusiness(this.formProInfo)
			  				
			  }
			  this.getDetailKpi(this.ofVillage)
		  },
		  getCurrentYearMonth() {
		      const now = new Date();
		      const year = now.getFullYear();
		      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以要加1，并确保是两位数
		      return `${year}-${month}`;
		  },
		  
		  choosebt(e){
			  console.log(1234567,e)
			  if(e=='month'){
				  const now = new Date()
				  this.value2 = this.getCurrentYearMonth()
				  this.value1 = ''
				  this.value3 = String(now.getFullYear())
				  this.formProInfo.month = this.value2.substring(this.value2.length - 2)
				  this.formProInfo.year = this.value3
				  this.formProInfo.date = this.value1
				  this.formProInfos.month = this.value2.substring(this.value2.length - 2)
				  this.formProInfos.year = this.value3
				  this.formProInfos.date = this.value1
				  this.formMeeting.month = this.value2.substring(this.value2.length - 2)
				  this.formMeeting.year = this.value3
				  if(this.tabPositiontype=='驻镇代表'){
				  					
				  		this.getData(this.formProInfo)
				  }else if(this.tabPositiontype=='终端准用户'){
				  		this.getDatas(this.formProInfos) 
				  				
				  }else if(this.tabPositiontype=='销量'){
				  		this.getPageGoods(this.formProInfo) 
				  				
				  }else if(this.tabPositiontype=='新商开发'){
				  		this.getDevelopDealer(this.formProInfo) 
				  				
				  }else if(this.tabPositiontype=='订购会'){
				  		this.getVisitDealer(this.formMeeting) 
				  				
				  }else{
				  		this.VisitDealerBusiness(this.formProInfo)
				  				
				  }
				  this.ofVillage.month = this.value2.substring(this.value2.length - 2)
				  this.ofVillage.year = this.value3
				  this.ofVillage.date = this.value1
				  this.getDetailKpi(this.ofVillage)
			  }else if(e=='year'){
				  this.value3 =  `${new Date().getFullYear()}`;
				  console.log(666666,this.value3)
				  this.value1 = ''
				  this.value2 = ''
				  this.formProInfo.month = this.value2.substring(this.value2.length - 2)
				  this.formProInfo.year = this.value3
				  this.formProInfo.date = this.value1
				  this.formProInfos.month = this.value2.substring(this.value2.length - 2)
				  this.formProInfos.year = this.value3
				  this.formProInfos.date = this.value1
				  this.formMeeting.month = this.value2.substring(this.value2.length - 2)
				  this.formMeeting.year = this.value3
				  if(this.tabPositiontype=='驻镇代表'){
				  					
				  		this.getData(this.formProInfo)
				  }else if(this.tabPositiontype=='终端准用户'){
				  		this.getDatas(this.formProInfos) 
				  				
				  }else if(this.tabPositiontype=='销量'){
				  		this.getPageGoods(this.formProInfo) 
				  				
				  }else if(this.tabPositiontype=='新商开发'){
				  		this.getDevelopDealer(this.formProInfo) 
				  				
				  }else if(this.tabPositiontype=='订购会'){
				  		this.getVisitDealer(this.formMeeting) 
				  				
				  }else{
				  		this.VisitDealerBusiness(this.formProInfo)
				  				
				  }
				   this.ofVillage.month = this.value2.substring(this.value2.length - 2)
				   this.ofVillage.year = this.value3
				   this.ofVillage.date = this.value1
				   this.getDetailKpi(this.ofVillage)
			  }else{
				  const dateObj = new Date();
				  const year = dateObj.getFullYear(); 
				  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
				  const day = String(dateObj.getDate()).padStart(2, "0");
				  const formattedDate = `${year}-${month}-${day}`;
				  this.value1 = formattedDate
				  this.value3 = ''
				  this.value2 = ''
				  this.formProInfo.month = this.value2.substring(this.value2.length - 2)
				  this.formProInfo.year = this.value3
				  this.formProInfo.date = this.value1
				  this.formProInfos.month = this.value2.substring(this.value2.length - 2)
				  this.formProInfos.year = this.value3
				  this.formProInfos.date = this.value1
				   if(this.tabPositiontype=='驻镇代表'){
				   					
				   		this.getData(this.formProInfo)
				   }else if(this.tabPositiontype=='终端准用户'){
				   		this.getDatas(this.formProInfos) 
				   				
				   }else if(this.tabPositiontype=='销量'){
				   		this.getPageGoods(this.formProInfo) 
				   				
				   }else if(this.tabPositiontype=='新商开发'){
				   		this.getDevelopDealer(this.formProInfo) 
				   				
				   }else if(this.tabPositiontype=='订购会'){
				   		this.getVisitDealer(this.formMeeting) 
				   				
				   }else{
				   		this.VisitDealerBusiness(this.formProInfo)
				   				
				   }
				   this.ofVillage.month = this.value2.substring(this.value2.length - 2)
				   this.ofVillage.year = this.value3
				   this.ofVillage.date = this.value1
				   this.getDetailKpi(this.ofVillage)
			  }
		  },
		  changetype(e){
			  
			  if(this.tabPositiontype=='驻镇代表'){
			  					
			  		this.getData(this.formProInfo)
			  }else if(this.tabPositiontype=='终端准用户'){
			  		this.getDatas(this.formProInfos) 
			  				
			  }else if(this.tabPositiontype=='销量'){
			  		this.getPageGoods(this.formProInfo) 
			  				
			  }else if(this.tabPositiontype=='新商开发'){
			  		this.getDevelopDealer(this.formProInfo) 
			  				
			  }else if(this.tabPositiontype=='订购会'){
			  		this.getVisitDealer(this.formMeeting) 
			  				
			  }else{
			  		this.VisitDealerBusiness(this.formProInfo)
			  				
			  }
			  
		  },
		  
		
       // 选择复选框事件
       selectChange(val) {
         this.selectdata = val
       },

        // 获取驻镇代表数据方法
        getData(pageparm) {
          this.loading = true
		  pageparm.dataType = '2'
          queryPageTown(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.proInfoList = res.data
			  this.proInfoList.map((item,index) =>{
				  item.zzdbArea = item.province + item.city + item.county
			  })
              // 分页赋值
              this.pageparm.currentPage = this.formProInfo.pageIndex
              this.pageparm.pageSize = this.formProInfo.pageSize
              this.pageparm.total = res.total
            }
          })
        },
		// 获取准用户信息发展数据方法
		getDatas(pageparm) {
		  this.loading = true
		  queryPageCustomer(pageparm).then(res => {
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.proInfoList = res.data
			  
		      // 分页赋值
		      this.pageparm.currentPage = this.formProInfos.pageIndex
		      this.pageparm.pageSize = this.formProInfos.pageSize
		      this.pageparm.total = res.total
		    }
		  })
		},
		// 获取订购会
		getVisitDealer(pageparm) {
		  this.loading = true
		  queryPageMeeting(pageparm).then(res => {
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.proInfoList = res.data
			  this.proInfoList.map((item,index) =>{
			  		 item.area = item.province + item.city + item.county
			  })
			  
		      // 分页赋值
		      this.pageparm.currentPage = this.formMeeting.pageIndex
		      this.pageparm.pageSize = this.formMeeting.pageSize
		      this.pageparm.total = res.total
		    }
		  })
		},
		// 获取销量数据方法
		getPageGoods(pageparm) {
		  this.loading = true
		  pageparm.dataType = '1'
		  queryPageSale(pageparm).then(res => {
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.proInfoList = res.data
			  
			  
		      // 分页赋值
		      this.pageparm.currentPage = this.formProInfo.pageIndex
		      this.pageparm.pageSize = this.formProInfo.pageSize
		      this.pageparm.total = res.total
		    }
		  })
		},
		// 获取新商拜访数据方法
		VisitDealerBusiness(pageparm) {
		  this.loading = true
		  pageparm.dataType = '0'
		  kpiDataVisitDealerHouse(pageparm).then(res => {
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.proInfoList = res.data
			  
			  
		      // 分页赋值
		      this.pageparm.currentPage = this.formProInfo.pageIndex
		      this.pageparm.pageSize = this.formProInfo.pageSize
		      this.pageparm.total = res.total
		    }
		  })
		},
		// 获取新商开发数据方法
		getDevelopDealer(pageparm) {
		  this.loading = true
		  pageparm.dataType = '0'
		  queryPageDevelopDealer(pageparm).then(res => {
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.proInfoList = res.data
			  
			  
		      // 分页赋值
		      this.pageparm.currentPage = this.formProInfo.pageIndex
		      this.pageparm.pageSize = this.formProInfo.pageSize
		      this.pageparm.total = res.total
		    }
		  })
		},
        // 分页插件事件
        callFather(parm) {
          
		  if(this.tabPositiontype=='驻镇代表'){
		  		this.formProInfo.pageIndex = parm.currentPage
		  		this.formProInfo.pageSize = parm.pageSize				
		  		this.getData(this.formProInfo)
		  }else if(this.tabPositiontype=='终端准用户'){
			    this.formProInfos.pageIndex = parm.currentPage
			    this.formProInfos.pageSize = parm.pageSize
		  		this.getDatas(this.formProInfos) 
		  				
		  }else if(this.tabPositiontype=='销量'){
			    this.formProInfo.pageIndex = parm.currentPage
			    this.formProInfo.pageSize = parm.pageSize	
		  		this.getPageGoods(this.formProInfo) 
		  				
		  }else if(this.tabPositiontype=='新商开发'){
			    this.formProInfo.pageIndex = parm.currentPage
			    this.formProInfo.pageSize = parm.pageSize	
		  		this.getDevelopDealer(this.formProInfo) 
		  				
		  }else if(this.tabPositiontype=='订购会'){
			    this.formMeeting.pageIndex = parm.currentPage
			    this.formMeeting.pageSize = parm.pageSize
		  		this.getVisitDealer(this.formMeeting) 
		  				
		  }else{
			    this.formProInfo.pageIndex = parm.currentPage
			    this.formProInfo.pageSize = parm.pageSize	
		  		this.VisitDealerBusiness(this.formProInfo)
		  				
		  }
		  
		  
		  
        },
		// 获取区域经理考核数据详情
		getDetailKpi(pageparm) {
		  this.loading = true
		  getDetailKpiDataOfRegionalManagerHouse(pageparm).then(res => {
		    console.log(123)
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.kpilist = res.data
			  this.percentagedata = this.kpilist[0].progressPercent
			  this.percentagedata1 = this.kpilist[1].progressPercent
			  this.percentagedata2 = this.kpilist[2].progressPercent
			  this.percentagedata3 = this.kpilist[3].progressPercent
			  this.percentagedata4 = this.kpilist[4].progressPercent
			  this.percentagedata5 = this.kpilist[5].progressPercent
		
		    }
		  })
		},


      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
  	  width: 220px;
  }
  .el-input{
  	  width: 140px;
  }
  /deep/ .el-input--small{
  	  width: 140px;
  }
  /deep/ .el-form--inline .el-form-item__label{
	  width: 80px;
	  overflow-wrap: break-word;
	  
  }
  /deep/ .huan .el-form-item__label{
  	  line-height: 20px;
  	  
  }
  .search{
	  position: absolute;
	  right: 0;
	  top: 63px;
  }
  .add{
	  margin-bottom: 30px;
  }
  .el-button--small{
	margin-top: 0px;  
  }
  .refrea{
	  position: absolute;
	  right: 0;
	  top: 5px;
  } 
  .user-search{
	  position: relative;
  }
  /deep/ .el-radio-button__inner{
	  width: 90px;
  }
  /deep/ .el-radio-button__inner{
	  padding: 8px 20px;
  }
  .block{
	  display: flex;
  }
  /deep/ .block .el-input__inner{
	  line-height: 32px;
	  height: 32px;
	  border: 0;
  }
  /deep/ .el-input__icon{
	  font-size: 20px;
	  height: 36px;
	  line-height: 32px;
  }
  .titleout{
	  width: 100%;
	  height: 60px;
	  display: flex;
	  justify-content: flex-start;
  }
  .title{
	  height: 60px;
	  line-height: 60px;
	  font-weight: bold;
	  font-size: 14px;
	  width: 250px;
  }
  .title1{
  	  height: 60px;
  	  line-height: 60px;
  	  font-size: 14px;
  	  width: 250px;
  }
  .jinduout{
	  width: 100%;
	  height: 92px;
	  display: flex;
	  justify-content: space-between;
	  margin-bottom: 30px;
  }
  .jindulist{
	  width: 24%;
	  height: 90px;
	  line-height: 20px;
	  border-radius: 4px;
	  background-color: rgba(222,134,143,0.13);
	  color: rgba(0,0,0,1);
	  font-size: 14px;
	  text-align: center;
	  font-family: -regular;
	  border: 1px solid rgba(222,134,143,1);
  }
  .jindulist1{
  	  width: 24%;
  	  height: 90px;
  	  line-height: 20px;
  	  border-radius: 4px;
  	  background-color: rgba(252,202,0,0.16);
  	  color: rgba(0,0,0,1);
  	  font-size: 14px;
  	  text-align: center;
  	  font-family: -regular;
  	  border: 1px solid rgba(252,202,0,1);
  }
  .jindulist2{
  	  width: 24%;
  	  height: 90px;
  	  line-height: 20px;
  	  border-radius: 4px;
  	  background-color: rgba(244,206,152,0.14);
  	  color: rgba(0,0,0,1);
  	  font-size: 14px;
  	  text-align: center;
  	  font-family: -regular;
  	  border: 1px solid rgba(244,206,152,1);
  }
  .jindulist3{
  	  width: 24%;
  	  height: 90px;
  	  line-height: 20px;
  	  border-radius: 4px;
  	  background-color: rgba(204,247,131,0.13);
  	  color: rgba(0,0,0,1);
  	  font-size: 14px;
  	  text-align: center;
  	  font-family: -regular;
  	  border: 1px solid rgba(204,247,131,1);
  }
  .jindulist4{
  	  width: 24%;
  	  height: 90px;
  	  line-height: 20px;
  	  border-radius: 4px;
  	  background-color: rgba(127,131,247,0.12);
  	  color: rgba(0,0,0,1);
  	  font-size: 14px;
  	  text-align: center;
  	  font-family: -regular;
  	  border: 1px solid rgba(127,131,247,1);
  }
  .jindulist5{
  	  width: 24%;
  	  height: 90px;
  	  line-height: 20px;
  	  border-radius: 4px;
  	  background-color: rgba(184,134,248,0.12);
  	  color: rgba(0,0,0,1);
  	  font-size: 14px;
  	  text-align: center;
  	  font-family: -regular;
  	  border: 1px solid rgba(184,134,248,1);
  }
  .shu{
	  width: 100%;
	  height: 29px;
	  line-height: 20px;
	  color: rgba(51,51,51,1);
	  font-size: 14px;
	  text-align: center;
	  font-family: PingFangSC-bold;
	  margin-top: 16px;
  }
  .titlejin{
	  height: 26px;
	  width: 100%;
	  line-height: 17px;
	  color: rgba(154,154,154,1);
	  font-size: 12px;
	  text-align: center;
	  font-family: PingFangSC-regular;
  }
  .shu1{
  	  width: 100%;
  	  line-height: 20px;
  	  color: rgba(51,51,51,1);
  	  font-size: 14px;
  	  text-align: center;
  	  font-family: PingFangSC-bold;
  	  margin-top: 15px;
  }
  .titlejin1{
  	  width: 100%;
  	  line-height: 17px;
  	  color: rgba(154,154,154,1);
  	  font-size: 12px;
  	  text-align: center;
  	  font-family: PingFangSC-regular;
  }
  .jundut{
	  width: 90%;
	  margin: 0 auto;
  }
  .titleout{
	  width: 100%;
	  display: flex;
	  justify-content: space-between;
	  
  }
  .mubiao{
	  font-size: 10px;
	  color: rgba(154,154,154,1) ;
  }
  /deep/ .el-radio-button__inner{
	  width: 120px;
  }
  .backcss{
  	  width: 6.25rem;
  	  height: 2.5rem;
  }
    </style>





// WEBPACK FOOTER //
// src/views/assessment/regionalManagerHouse.vue